export default {
  MUTATION: 'mutation',
  QUERY: 'query',
  DIALOG: 'dialog',
  ERROR: 'error',
  CLICK: 'click',
};
